import { Auth } from 'aws-amplify'
import { CognitoAuth } from 'amazon-cognito-auth-js'
import { OPENID_CONNECT } from '@/environment'

const federatedAuth = new CognitoAuth(OPENID_CONNECT)

/**
 * ログイン処理
 * @param {string} email メールアドレス
 * @param {string} password パスワード
 * @returns {Promise<any>} コールバック
 */
export function signIn (email, password) {
  return Auth.signIn(email, password)
}

/**
 * ログアウト処理
 * @returns {Promise<any>} コールバック
 */
export async function signOut () {
  await Auth.signOut({ global: true })
  await federatedAuth.signOut()
}

/**
 * ログインしたユーザ名を取得する
 * @returns {Promise<any>} コールバック
 */
export function getUsername () {
  return Auth.currentSession().then(session => {
    return new Promise(function (resolve) {
      resolve(session.idToken.payload.email || session.idToken.payload.name)
    })
  })
}

/**
 *
 * @param {string} url
 * @returns {Promise<any>}
 */
export function federatedSignIn (url) {
  return new Promise((resolve, reject) => {
    federatedAuth.userhandler = {
      onSuccess: () => {
        resolve()
      },
      onFailure: error => {
        reject(error)
      }
    }
    federatedAuth.useCodeGrantFlow()
    federatedAuth.parseCognitoWebResponse(url)
  })
}

/**
 * To get current logged in user information
 */
export function currentLoggedInUser () {
  return Auth.currentUserInfo()
}
